import React from "react";
import { object, string } from "prop-types";
import get from "lodash/get";

import { staticTexts } from "../../utils/Translate";
import { getStoryDate } from "../../utils/utils";

import "./liveText.m.css";

const LiveText = ({ story, lang = "en", titleText = null }) => {
  const isClosed = get(story, ["metadata", "is-closed"], false);
  const lastPublishedAt = get(story, ["last-published-at"], null);

  return isClosed ? (
    <div className="live-text" styleName="live-text">
      {staticTexts(lang).liveEndText} {lastPublishedAt ? getStoryDate(lastPublishedAt, lang) : ""}
    </div>
  ) : (
    <div styleName="live-text">
      <div className="dot-wrapper" styleName="dot-wrapper">
        <div className="dot" styleName="dot dot--basic"></div>
      </div>
      <div className="live-text-with-title">
        <div className="live-text">{staticTexts(lang).liveText}</div>
        <div styleName="live-title-text" className="live-title-text">
          {titleText}
        </div>
      </div>
    </div>
  );
};

LiveText.propTypes = {
  story: object.isRequired,
  lang: string,
  titleText: string,
};

export default LiveText;
